import { Router } from "@angular/router";
import { BehaviorSubject } from "rxjs";
import { Injectable, Injector } from "@angular/core";
import { CookieService } from "ngx-cookie-service";
import { ApiService } from "../../../services/api.service";
import Swal from "sweetalert2";
import { HttpClient } from "@angular/common/http";
// import { MatSnackBar } from '@angular/material';

@Injectable()
export class AuthService {
  userData: any;
  autotransId: void;
  autoTranid: any;
  autoRepayid: any;
  constructor(
    private router: Router,
    private injector: Injector,
    private apiService: ApiService,
    private http: HttpClient
  ) {}
  private loggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  private Mobilenumber = "";
  private Password = "";
  OTPStatus = new BehaviorSubject<boolean>(false);
  // isloggedin = false;
  get isLoggedIn() {
    return this.loggedIn.asObservable();
  }
  public isAuthenticated(): boolean {
    const user = localStorage.getItem("token");
    if (user) {
      return true;
    }
    return false;
  }

  login(user: any) {
    this.apiService.getLogin(user).subscribe((data) => {
      console.log(data, "login details");

      if (!data.error) {
        // Swal.fire("Success!!", data.message);
        // this.router.navigate(['/apps/dashboard']);
        localStorage.setItem("user", data.userdata.Name);
        localStorage.setItem("token", data.token);
        localStorage.setItem("usertype", data.userdata.Id);
        localStorage.setItem("userbranchtype", data.userdata.BranchId);
        localStorage.setItem("userCompanytype", data.userdata.CompanyId);
        localStorage.setItem("userData", JSON.stringify(data.userdata));

        data.userdata.PaymentTypeMasterDetails.filter((item) => {
          if (item.PaymentTypeName == "AutoTransfer") {
            this.autoTranid = item.PaymentTypeId;
          } else if (item.PaymentTypeName == "AutoRepayment") {
            this.autoRepayid = item.PaymentTypeId;
          }
        });

        console.log(this.autoTranid);
        console.log(this.autoRepayid);

        localStorage.setItem("this.autoTranid", this.autoTranid);
        localStorage.setItem("this.autoRepayid", this.autoRepayid);

        localStorage.setItem(
          "userroletype",
          data.userdata.UserRoles[0].UserType
        );
        localStorage.setItem(
          "paymentType",
          JSON.stringify(data.userdata.PaymentTypeMasterDetails)
        );
        this.loggedIn.next(true);
        localStorage.removeItem("ActiveItem");
        localStorage.removeItem("parents");
        localStorage.removeItem("childs");
        this.router.navigate(["/apps/dashboard"]);
      } else {
        // this.router.navigate(['/apps/login/login']);
        Swal.fire("Error!!", data.message);
      }
      // } else {
      // Swal.fire("Error!!","Please Contact Administrator");
      // }
    });
  }
  public isAuthenticated1(): boolean {
    const user = localStorage.getItem("user");
    if (user) {
      return true;
    }
    return false;
  }

  cancelOTPStatus() {
    this.OTPStatus.next(false);
  }

  Forgetpassword(user: any) {
    this.apiService.ForgetpasswordSendOtp(user).subscribe((data) => {
      // if(data.code != 400){
      if (!data.error) {
        localStorage.setItem("mobileNumber", user.MobileNumber);
        Swal.fire("success!!", data.message);
        this.OTPStatus.next(true);
        this.router.navigate(["/apps/forgotpassword/Forgotpassword"]);
      } else {
        Swal.fire("Erorr!!", data.message);
        this.OTPStatus.next(false);
        this.router.navigate(["/apps/forgotpassword/Forgotpassword"]);
      }
    });
  }
  completeAuthentication(status): Promise<string> {
    return status;
  }

  logout() {
    this.loggedIn.next(false);
    localStorage.clear();
    sessionStorage.clear();
    //document.location.reload();
  }
}

export class User {
  name: string;
  Password: string;
  rememberme: boolean;
}
